import { Field } from 'redux-form';
import { Select } from '@mews-commander/ui';
import { getError } from '../../utils';

export const SelectFieldRenderer = ({ input, meta, ...other }: $TSFixMe) => (
    <Select selected={input.value} error={getError(meta)} {...input} {...other} />
);

export type SelectFieldProps = $TSFixMe;

export const SelectField = (props: SelectFieldProps) => <Field component={SelectFieldRenderer} {...props} />;
